import { useEffect, useState } from 'react';

import useUser from 'api/hooks/useUser';

const useLanguage = () => {
  const [blue, $blue] = useState<string>('');
  const [green, $green] = useState<string>('');
  const { data } = useUser();

  useEffect(() => {
    if (data) {
      $blue(data?.blueLang);
      $green(data?.greenLang);
    }

    return;
  }, [data]);

  return { blueLang: blue,
    greenLang: green };
};

export default useLanguage;
